














import Vue from 'vue'

export default Vue.extend({
  name: 'DdIconButton',

  props: {
    /* circle or rounded */
    type: {
      type: String,
      default: 'circle',
    },

    /* grey, dark-grey, blue, green */
    color: {
      type: String,
      default: 'grey',
    },

    /* small, medium, or large */
    size: {
      type: String,
      default: 'large',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    /* Name of icon -- e.g. 'conversation' for ddi-conversation icon */
    icon: {
      type: String,
      required: true,
    },

    /* Makes the passed in icon red */
    danger: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modifiers(): Array<String> {
      const baseSelector = 'dd-icon-button--'

      // Colors
      const selectors = [
        baseSelector + this.size,
        baseSelector + this.type,
        baseSelector + this.color,
      ]

      if (this.danger) {
        selectors.push('dd-icon-button--danger')
      }

      if (this.isDisabled) {
        selectors.push('dd-icon-button--disabled')
      }
      return selectors
    },
  },
})
